/**
 * @generated SignedSource<<a8d7a56bb16b6544ea5f49b0e42b79ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimeOffMiniPicker_account$data = {
  readonly default_full_time_minutes: number;
  readonly id: number;
  readonly " $fragmentSpreads": FragmentRefs<"EffortInput_account" | "TimeOffEffortInputs_account" | "TotalEffortInput_account">;
  readonly " $fragmentType": "TimeOffMiniPicker_account";
};
export type TimeOffMiniPicker_account$key = {
  readonly " $data"?: TimeOffMiniPicker_account$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimeOffMiniPicker_account">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeOffMiniPicker_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "default_full_time_minutes",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EffortInput_account"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TotalEffortInput_account"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeOffEffortInputs_account"
    }
  ],
  "type": "accounts",
  "abstractKey": null
};

(node as any).hash = "99779a2796dd513694703d66691ee4c9";

export default node;
